import type {
  EmbeddingModel,
  KnowledgeBase,
  KnowledgeBaseListResult,
} from "../../domain/entities/knowledge-base";
import type {
  KnowledgeBaseListModel,
  KnowledgeBaseModel,
  MetadataModel,
} from "../models/knowledge-base-model";

const toKnowledgeBase = (model: KnowledgeBaseModel): KnowledgeBase => ({
  id: model._id,
  userId: model.user_id,
  name: model.name,
  chunkingConfig: {
    chunkSize: model.chunking_config.chunk_size,
    chunkOverlap: model.chunking_config.chunk_overlap,
    embeddingModelCode: model.chunking_config.embedding_model,
  },
});

export const toKnowledgeBaseList = (
  model: KnowledgeBaseListModel,
): KnowledgeBaseListResult => ({
  items: model.items.map(toKnowledgeBase),
  total: model.total,
});

export { toKnowledgeBase };

export const toEmbeddingModels = (model: MetadataModel): EmbeddingModel[] =>
  model.embedding ?? model.embeddingModels ?? [];
